import * as React from 'react';
import type { PatchOutlookSpaceAsset } from 'owa-timestream-types';
import { patchAssetPayload } from 'owa-timestream-store';
import { useAssetId } from './useAssetId';
import { useProjectId } from './useProjectId';

/**
 * Use this hook to update the payload of the current asset.
 *
 * Being a hook, this should be called from the rendering function of an asset.
 * The returning function is bound to the ID of the asset being rendered.
 * The end result is that an asset can update its own payload without having to know its ID.
 */
export default function usePatchPayload<TPayload>() {
    const assetId = useAssetId();
    const projectId = useProjectId();
    const patchPayload: (
        payload: TPayload,
        newTaskId?: Pick<PatchOutlookSpaceAsset, 'taskId'>
    ) => void = React.useMemo(() => patchAssetPayload.bind(null, projectId, assetId, false), [
        assetId,
    ]);
    return patchPayload;
}
